
import NonLeagueImage from '../assets/images/NON-LEAGUE-white-bg.png';
import NonLeagueManagementImage from '../assets/images/Non-League-Live-Management-app-logo-white-bg.png';

import Screenshot1 from '../assets/images/AppDetailsPageSS1.png';
import Screenshot2 from '../assets/images/AppDetailsPageSS2.png';
import Screenshot3 from '../assets/images/AppDetailsPageSS3.png';
import Screenshot4 from '../assets/images/AppDetailsPageSS4.png';
import Screenshot5 from '../assets/images/AppDetailsPageSS5.png';
import Screenshot6 from '../assets/images/AppDetailsPageSS6.png';
import Screenshot7 from '../assets/images/AppDetailsPageSS7.png';
import Screenshot8 from '../assets/images/AppDetailsPageSS8.png';

import Screenshot9 from '../assets/images/AppDetailPageMMSS1.png';
import Screenshot10 from '../assets/images/AppDetailPageMMSS2.png';
import Screenshot11 from '../assets/images/AppDetailPageMMSS3.png';
import Screenshot12 from '../assets/images/AppDetailPageMMSS4.png';

export const appDetails = {
  'non-league-live': {
    title: 'Non League Live',
    description: 'A platform to follow your favorite non-league football teams.',
    imageUrl: NonLeagueImage,
    detailedDescription:
      'Non League Live is an innovative app designed to keep football fans updated with the latest scores, fixtures, and league standings for non-league football teams. Whether you are a fan of your local club or just love the game, this app provides real-time updates and a user-friendly experience.',
    features: [
      'Real-time score updates',
      'See the table live',
      'Mobile-friendly design',
      'Notifications for match events',
    ],
    screenshots: [
      Screenshot1,
      Screenshot2,
      Screenshot3,
      Screenshot4,
      Screenshot5,
      Screenshot6,
      Screenshot7,
      Screenshot8,
    ],
    privacyPolicy: `Privacy Policy for NonLeague Live
      Effective Date: 26/07/2025

      At Non League Live, your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your personal information when you use our app.

      Information We Collect:

      We do not collect any personally identifiable information (such as your name, email, or location) unless you voluntarily provide it within the app.

      We may collect non-personal data such as device information and usage statistics to improve app performance.

      How We Use Your Information:

      To provide live football scores, fixtures, and league updates.

      To improve app functionality and user experience.

      We do not sell, rent, or share your personal information with third parties.

      Data Security:

      We take reasonable measures to protect your data from unauthorized access or disclosure.

      Children’s Privacy:

      Our app is suitable for all ages, but if you are under 13, please get permission from a parent or guardian before using the app.

      We do not knowingly collect personal information from children under 13.

      Changes to This Policy:

      We may update this Privacy Policy from time to time. We will notify you of any changes by updating the date above.

      Contact Us:
      If you have any questions or concerns about your privacy, please contact us at admin@nonleaguelive.uk
  `,
  },
  'non-league-live-management': {
    title: 'Non League Live - Management',
    description: 'A platform for clubs to update scores for their non-league football teams.',
    imageUrl: NonLeagueManagementImage,
    detailedDescription:
      'This app allows club managers to easily update match scores, player statistics, and other relevant information in real-time, ensuring fans have the latest updates on their favorite teams.',
    features: [
      'Update scores and statistics in real-time',
      'User-friendly interface',
      'Secure login for club managers',
    ],
    screenshots:[
      Screenshot9,
      Screenshot10,
      Screenshot11,
      Screenshot12,
    ],
    privacyPolicy: `Privacy Policy for NonLeague Live Management
      Effective Date: 26/07/2025

      At Non League Live Management, your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your personal information when you use our app.

      Information We Collect:

      We do not collect any personally identifiable information (such as your name, email, or location) unless you voluntarily provide it within the app.

      We may collect non-personal data such as device information and usage statistics to improve app performance.

      How We Use Your Information:

      To allow club managers to update match scores and statistics.

      To improve app functionality and user experience.

      We do not sell, rent, or share your personal information with third parties.

      Data Security:

      We take reasonable measures to protect your data from unauthorized access or disclosure.

      Children’s Privacy:

      Our app is suitable for all ages, but if you are under 13, please get permission from a parent or guardian before using the app.

      We do not knowingly collect personal information from children under 13.

      Changes to This Policy:

      We may update this Privacy Policy from time to time. We will notify you of any changes by updating the date above.

      Contact Us:
      If you have any questions or concerns about your privacy, please contact us at admin@nonleaguelive.uk`,
  },
};